import { PhysicalClientAddress, physicalClientAddressesApi } from "@/lib/api";
import { AddressListView, AddressSection } from "./AddressListView";
import { useAddressBook } from "./useAddressBook";

const physicalClientAddressesQueryKey = (physicalClientId?: number) =>
  ["physical-client-addresses", physicalClientId] as const;

interface PhysicalClientAddressListProps {
  physicalClientId?: number;
  /** Query do cliente a invalidar (os padrões aparecem no cabeçalho do detalhe). */
  physicalClientQueryKey?: readonly unknown[];
}

const SECTIONS: AddressSection[] = [
  {
    type: "Billing",
    title: "Endereço de cobrança",
    description: "Endereço usado na cobrança do cliente.",
  },
  {
    type: "Shipping",
    title: "Endereço de entrega",
    description: "Endereços para entrega. Pedidos de pessoa física ainda não usam estes endereços.",
  },
];

/** Endereços do cliente pessoa física: mesmas regras e telas do cliente CNPJ, sem o espelho no cadastro legado. */
export function PhysicalClientAddressList({ physicalClientId, physicalClientQueryKey }: PhysicalClientAddressListProps) {
  const book = useAddressBook<PhysicalClientAddress>({
    queryKey: physicalClientAddressesQueryKey(physicalClientId),
    ownerId: physicalClientId,
    api: physicalClientAddressesApi,
    invalidateKeys: [physicalClientQueryKey],
  });
  return (
    <AddressListView
      book={book}
      sections={SECTIONS}
      dialogDescription="Cada finalidade tem um endereço padrão. O primeiro endereço cadastrado de cada finalidade vira o padrão."
      allowSameForShipping
      errorMessage="Não foi possível carregar os endereços do cliente."
    />
  );
}
